import { render } from "./QRCodesComponent.vue?vue&type=template&id=3a4e70f8"
import script from "./QRCodesComponent.vue?vue&type=script&lang=js"
export * from "./QRCodesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__